/* 🤖 this file was generated by svg-to-ts */
export const emperorIconClockOutline: {
  name: 'clock_outline';
  data: string;
} = {
  name: 'clock_outline',
  data: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M29 15C29 13.375 30.25 12 32 12C33.625 12 35 13.375 35 15V30.5L45.625 37.5C47 38.5 47.375 40.375 46.375 41.75C45.5 43.125 43.625 43.5 42.25 42.5L30.25 34.5C29.5 34 29 33 29 32V15ZM32 0C49.625 0 64 14.375 64 32C64 49.75 49.625 64 32 64C14.25 64 0 49.75 0 32C0 14.375 14.25 0 32 0ZM6 32C6 46.375 17.625 58 32 58C46.25 58 58 46.375 58 32C58 17.75 46.25 6 32 6C17.625 6 6 17.75 6 32Z" fill="currentColor"/></svg>`
};
